/**
 * @class
 * @function UgcCarousel
 */
if (!customElements.get('ugc-carousel')) {
	class UgcCarousel extends HTMLElement {
		constructor() {
			super();
			this.swiper = null;
			this.swiperEl = this.querySelector('.ugc-carousel__swiper');
		}

		connectedCallback() {
			if (!this.swiperEl) return;

			// Wait for Swiper to be loaded
			if (typeof Swiper === 'undefined') {
				setTimeout(() => this.initSwiper(), 100);
				return;
			}

			this.initSwiper();
		}

		updateArrowVisibility() {
			if (!this.swiper) return;

			const nextButton = this.querySelector('.ugc-carousel__nav--next');
			const prevButton = this.querySelector('.ugc-carousel__nav--prev');

			if (nextButton) {
				if (this.swiper.allowSlideNext) {
					nextButton.classList.remove('ugc-carousel__nav--hidden');
				} else {
					nextButton.classList.add('ugc-carousel__nav--hidden');
				}
			}

			if (prevButton) {
				if (this.swiper.allowSlidePrev) {
					prevButton.classList.remove('ugc-carousel__nav--hidden');
				} else {
					prevButton.classList.add('ugc-carousel__nav--hidden');
				}
			}
		}

		initSwiper() {
			if (typeof Swiper === 'undefined') {
				setTimeout(() => this.initSwiper(), 100);
				return;
			}

			if (this.swiper) {
				this.swiper.destroy(true, true);
			}

			const slides = this.swiperEl.querySelectorAll('.swiper-slide');
			if (slides.length === 0) return;

			const nextButton = this.querySelector('.ugc-carousel__nav--next');
			const prevButton = this.querySelector('.ugc-carousel__nav--prev');

			this.swiper = new Swiper(this.swiperEl, {
				slidesPerView: 'auto',
				spaceBetween: 20,
				/* CSS padding on .swiper does not inset slides; matches recipe carousel 15px */
				slidesOffsetBefore: 15,
				speed: 600,
				loop: false,
				watchOverflow: true,
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				breakpoints: {
					768: {
						slidesPerView: 1.5,
						spaceBetween: 20,
						slidesOffsetBefore: 0,
					},
					863: {
						slidesPerView: 2,
						spaceBetween: 20,
						slidesOffsetBefore: 0,
					},
					1251: {
						slidesPerView: 3,
						spaceBetween: 20,
						slidesOffsetBefore: 0,
					},
				},
				on: {
					init: () => {
						// Show carousel after Swiper initializes
						this.setAttribute('data-swiper-ready', '');
						// Force update after init
						if (this.swiper) {
							this.swiper.update();
							this.updateArrowVisibility();
						}
					},
					slideChange: () => {
						this.updateArrowVisibility();
					},
					resize: () => {
						this.updateArrowVisibility();
					},
					update: () => {
						this.updateArrowVisibility();
					},
				},
			});
		}

		disconnectedCallback() {
			if (this.swiper) {
				this.swiper.destroy(true, true);
				this.swiper = null;
			}
		}
	}

	customElements.define('ugc-carousel', UgcCarousel);
}
